import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import "./css/menu.css";

var Types = {
  enum: {
    COLLAPSED: "collapsed",
    PROJECTS: "projects",
    TALKS: "talks",
  },
};

class Menu extends Component {
  static propTypes = {
    type: PropTypes.oneOf([Types.enum.PROJECTS, Types.enum.TALKS, ""]),
  };

  constructor(props) {
    super(props);
    this.state = {
      type: Types.enum.COLLAPSED,
    };
  }

  componentDidMount() {
    this.props.history.listen((location) => {
      if (location.hash === "#top") {
        if (this.props.type) {
          this.setState({ type: this.props.type });
        }

        const { pathname, search } = location;
        const newUrl = `${pathname}${search}`;
        this.props.history.replace(newUrl);
      }
    });
  }

  render() {
    return (
      <div className="header" id="menu">
        <div className="section">
          <div className="name">
            <a href="/">Mihai Cernusca</a>
          </div>
          <div className="menu">
            <ul>
              <li>
                <a href="#work" onClick={this.handleProjectsClick}>
                  Selected work
                </a>
              </li>
              <li>
                <a href="#talks" onClick={this.handleTalksClick}>
                  Talks
                </a>
              </li>
              <li>
                <a href="/about">About</a>
              </li>
            </ul>
          </div>
          {this.renderProjects()}
          {this.renderTalks()}
        </div>
      </div>
    );
  }

  renderProjects() {
    if (this.state.type !== Types.enum.PROJECTS) {
      return null;
    }
    return (
      <div className="projects">
        <a href="/flexhouse">
          <div className="box flexhouse">
            <div className="label">
              <div className="title">
                <div className="name">Flexhouse</div>
                <div className="tagline">Standardizing systems of building</div>
              </div>
              <div className="timeline">2024</div>
            </div>
            <div className="overlay" />
          </div>
        </a>
        <a href="/re-collect">
          <div className="box recollect">
            <div className="label">
              <div className="title">
                <div className="name">re:collect</div>
                <div className="tagline">Tools for the second pass</div>
              </div>
              <div className="timeline">2021—24</div>
            </div>
            <div className="overlay" />
          </div>
        </a>
        <a href="/whereby">
          <div className="box whereby">
            <div className="label">
              <div className="title">
                <div className="name">Whereby</div>
                <div className="tagline">Where better meetings happen</div>
              </div>
              <div className="timeline">2019—21</div>
            </div>
            <div className="overlay" />
          </div>
        </a>
        <a href="/america-off-balance">
          <div className="box americaoffbalance">
            <div className="label">
              <div className="title">
                <div className="name">America Off Balance</div>
                <div className="tagline">Interactive storytelling experience — Let's talk about the national debt</div>
              </div>
              <div className="timeline">2018</div>
            </div>
            <div className="overlay" />
          </div>
        </a>
        <a href="/swipe">
          <div className="box swipe">
            <div className="label">
              <div className="title">
                <div className="name">Swipe</div>
                <div className="tagline">Taking presentations beyond the&nbsp;projector</div>
              </div>
              <div className="timeline">2014—16</div>
            </div>
            <div className="overlay" />
          </div>
        </a>
        <a href="/gifshop">
          <div className="box gifshop">
            <div className="label">
              <div className="title">
                <div className="name">GIF SHOP</div>
                <div className="tagline">The animated .gif maker</div>
              </div>
              <div className="timeline">2010—14</div>
            </div>
            <div className="overlay" />
          </div>
        </a>
        {/* <a href="/brite">
          <div className="box brite">
            <div className="label">
              <div className="title">
                <div className="name">BriteIM</div>
                <div className="tagline">Tackling team communication</div>
              </div>
              <div className="timeline">2014</div>
            </div>
            <div className="overlay" />
          </div>
        </a> */}
        {/* <a href="/setlist">
          <div className="box setlist">
            <div className="label">
              <div className="title">
                <div className="name">Setlist</div>
                <div className="tagline">Discover local shows using artists in your Rdio collection</div>
              </div>
              <div className="timeline">2012</div>
            </div>
            <div className="overlay" />
          </div>
        </a> */}
      </div>
    );
  }

  renderTalks() {
    if (this.state.type !== Types.enum.TALKS) {
      return null;
    }
    return (
      <div className="projects">
        <a href="/off-balance">
          <div className="box offbalance">
            <div className="label">
              <div className="title">
                <div className="name">Off Balance</div>
                <div className="tagline">Interactive Storytelling with React</div>
              </div>
              <div className="timeline">React Rally 2019</div>
            </div>
            <div className="overlay" />
          </div>
        </a>
        <a href="/preventdefault">
          <div className="box preventdefault">
            <div className="label">
              <div className="title">
                <div className="name">Prevent Default</div>
                <div className="tagline">The future of authoring tools</div>
              </div>
              <div className="timeline">Front Trends 2017</div>
            </div>
            <div className="overlay" />
          </div>
        </a>
      </div>
    );
  }

  // Event Handlers

  handleProjectsClick = (event) => {
    event.preventDefault();
    var state = Types.enum.PROJECTS;
    if (state === this.state.type) {
      state = Types.enum.COLLAPSED;
    }
    this.setState({
      type: state,
    });
  };

  handleTalksClick = (event) => {
    event.preventDefault();
    var state = Types.enum.TALKS;
    if (state === this.state.type) {
      state = Types.enum.COLLAPSED;
    }
    this.setState({
      type: state,
    });
  };
}

export default withRouter(Menu);



// WEBPACK FOOTER //
// ./src/menu.js